// src/pages/Invoices/Report/InvoiceProfitReport.jsx
import React from 'react';
import ProfitReportPage, { INVOICE_PROFIT } from './ProfitReportPage';

export default function InvoiceProfitReport() {
  return <ProfitReportPage config={INVOICE_PROFIT} />;
}
